import type {ReactNode} from 'react'
import {WebGLBrandedDivider} from '@github-ui/brand-webgl'
import {useBrandTreatment} from '../useBrandTreatment'

interface BrandedDividerProps {
  className?: string
  enabled?: boolean
}

type UseBrandedDividerReturn = {
  hasBrandedDivider: boolean
  BrandedDivider: () => ReactNode
}

const EMPTY_BRANDED_DIVIDER: UseBrandedDividerReturn = {
  hasBrandedDivider: false,
  BrandedDivider: () => null,
}

export function useBrandedDivider(props?: BrandedDividerProps): UseBrandedDividerReturn {
  const {className, enabled = true} = props || {}
  const {brand, brandedDivider} = useBrandTreatment()

  if (!enabled || !brand || !brandedDivider) {
    return EMPTY_BRANDED_DIVIDER
  }

  return {
    hasBrandedDivider: true,
    BrandedDivider: () => <WebGLBrandedDivider key={brand} className={className} {...brandedDivider} />,
  }
}
